// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"cb493dcb","360":"5ed91e8f","449":"398da92a","492":"f6a4f7b6","521":"50221a62"}[chunkId] + ".chunk.css";
};